import ReducerUtilities from '../../../shared/store/reducer-utilities';
import formModel from '../../models/form';
import departmentCommitTypes from './commit-types';

const INITIAL_DEPARTMENT_STATE = {
  formFor: null,
  forms: null,
  isLoading: [],
};

function departmentReducers(state = INITIAL_DEPARTMENT_STATE, action) {
  if (!action || !action.type) {
    return state;
  }
  switch (action.type) {
    case departmentCommitTypes.PUSH_DEPARTMENT_FORMS:
      return {
        ...state,
        forms: [...action.forms.map(item => formModel(item))],
      };
    case departmentCommitTypes.RESET_DEPARTMENT_STATE:
      return { ...INITIAL_DEPARTMENT_STATE };
    case departmentCommitTypes.SET_DEPARTMENT_IS_LOADING:
      return {
        ...state,
        isLoading: ReducerUtilities.updateIsLoading(action.isLoading, state.isLoading),
      };
    case departmentCommitTypes.SET_FORM_FOR:
      return {
        ...state,
        formFor: action.formFor,
      };
    default:
      return state;
  }
}

export default departmentReducers;
